var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 547,
    height: 150,
    viewBox: "0 0 547 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0155053 83.5013C-0.341903 58.8401 5.37664 25.7798 27.8934 11.8409C38.2582 5.40757 54.3416 4.51403 69.7101 3.4418C139.583 -1.91932 212.674 0.225126 283.083 1.65476C325.257 2.54828 367.253 3.79917 409.248 5.4075C445.882 6.83714 486.984 6.47982 522.01 12.1983C538.987 14.8789 549.173 22.3845 545.421 40.791C542.025 57.4105 542.025 74.5661 543.455 91.3643C544.527 104.231 547.744 119.6 540.774 131.93C533.805 144.439 521.117 150.158 507.535 149.801C443.023 148.728 377.081 149.801 313.105 146.941C266.106 144.797 219.107 142.474 172.108 141.401C145.838 140.865 13.597 150.158 7.5211 131.93C3.41091 118.527 0.372914 101.193 0.0155053 83.5013Z",
    fill: "#6F3448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallRed);
export default __webpack_public_path__ + "static/media/SmallRed.812d88f88d32b90ecd1ba2de85f0df7a.svg";
export { ForwardRef as ReactComponent };